import React from "react";

const YouTubePlayer = ({ videoId }) => {
  return (
    <div className='bg-gray-50 md:px-[192px] px-4 py-20'>
      <div className='text-center mb-12'>
        <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>See Us In Action</p>
        <div className='flex items-center justify-center gap-4 mb-4'>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
        </div>
        <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900' style={{ fontFamily: 'Playfair Display, serif' }}>
          Watch Us <span className='text-[#E40F94] italic'>Dance</span>
        </h1>
        <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
      </div>

      {/* YouTube Video */}
      <div className='w-full max-w-4xl mx-auto'>
        <div className='relative w-full aspect-video rounded-2xl overflow-hidden shadow-2xl'>
          <iframe
            className='absolute top-0 left-0 w-full h-full'
            src={`https://www.youtube.com/embed/${videoId}`}
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>



      <div className='text-center mt-10'>
        <p className='text-gray-500 text-[15px] mb-6'>Don't miss our latest videos — Watch, Like, and Subscribe!</p>
        <a href='https://www.youtube.com/@ChilankaDanceSchool' target="_blank" rel="noopener noreferrer">
          <button className='bg-[#E40F94] text-white px-10 py-4 rounded-full text-[15px] font-semibold hover:bg-[#c00c7b] transition-colors duration-300 shadow-lg'>
            Visit Our YouTube Channel
          </button>
        </a>
      </div>
    </div>
  );
};

export default YouTubePlayer;
